<div class="copilot-layout container">
  <div class="copilot-left">
    <div style="word-break: break-word;" [style.color]="item.customField28"
      [ngStyle]="{'font-family': item.fontFamily}">
      <calsoft-editor-text [data]="data" [id]="item.customField35" [ngStyle.gt-md]="{'font-size': item.customField18 }"
        [ngStyle.lt-md]="{
                                                            
                                                            'font-size': item.customField17
                                                        }" [text]="item?.title" [align]="item.customField34">
      </calsoft-editor-text>
    </div>
    <div>

      <calsoft-editor-text style="max-width:97%;  min-width: 100px; word-break: break-word;
                                                overflow-wrap: break-word;
                                                white-space: normal;" [data]="data" [matIcon]="item.customField4"
        [ngStyle.gt-md]="{'font-size': item.customField37 }" [ngStyle.lt-md]="{
                                                    
                                                    'font-size': item.customField38
                                                }" [text]="item?.customField1"
        [ngStyle]="{'font-family': item.fontFamily || 'Poppins,sans-serif!important'}" [align]="item.customField34"
        [id]="item.customField35">
      </calsoft-editor-text>
    </div>
    <div class="copilot-social">
      <img class="whatsapp" [src]="serverPath+item.customField31" alt="WhatsApp" />
      <img class="instagram" [src]="serverPath+item.customField32" alt="Instagram" />
    </div>
    <button class="copilot-cta" [style.border-radius]="item.customField11"
      [ngStyle.gt-md]="{'font-size': item.customField25 }" [ngStyle.lt-md]="{'font-size': item.customField26}"
      *ngIf="item.images[0].navigation==0  && item.customField5.length > 0"
      (click)="goToCategories(item.images[0].customField2)">{{item.customField5}}</button>
    <button class="copilot-cta" [style.border-radius]="item.customField11"
      [ngStyle.gt-md]="{'font-size': item.customField25 }" [ngStyle.lt-md]="{'font-size': item.customField26}"
      *ngIf="item.images[0].navigation==1   && item.customField5.length > 0"
      (click)="link(item.images[0].navigatedUrl)">{{item.customField5}}</button>
    <button class="copilot-cta" [style.border-radius]="item.customField11"
      [ngStyle.gt-md]="{'font-size': item.customField25 }" [ngStyle.lt-md]="{'font-size': item.customField26}"
      *ngIf="item.images[0].navigation==2   && item.customField5.length > 0"
      (click)="dynamicFormPopup(item.customField2)">{{item.customField5}}</button>
  </div>
  <div class="copilot-right">
    <div class="copilot-media">
      <!-- <video src="assets/videos/estimate-demo.mp4" [ngStyle.lt-md]="{'height': item.heightMob}"
        [style.height]="item.height" controls poster="assets/images/pdf-estimate-poster.png"></video> -->
      <div *ngFor="let img of item.images">


        <ng-container *ngIf="img.type==2">
          <div>
            <div style="width: 100%;height:500px" ngStyle.lt-md="height:100%">
              <iframe style="width: 100%; height: 100%;" [src]="youtubeUrl+img.img | safe: 'resourceUrl'"></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="img.type==1">
          <div [style.padding]="img.customField21" contentAnim [aniName]="item.customField36"
            [ngClass]="{'cardzoom': img.customField9 === '1'}">
            <!-- <img style="width:100% ;" [style.height]="item.height" 
                                        [style.margin-right]="item.gapBetweenImage"
                                        [ngClass]="{'container': item.customField20 === '4'}"
                                        [ngStyle.lt-md]="{'height': item.heightMob}"
                                        (click)="img.navigation==0?goToCategories(img.catId):link(img.navigatedUrl)"
                                        [src]="serverPath+img.img" [alt]="img.altImage || 'images' "> -->
            <img style="width:100% ;" class="padding" [style.height]="item.height"
              [style.box-shadow]="img.customField20 == 1 ? '0px 8px 25px -11px' : 'none'"
              [style.margin-right]="item.gapBetweenImage" [ngStyle.lt-md]="{'height': item.heightMob}"
              (click)="img.navigation==0?goToCategories(img.catId):link(img.navigatedUrl)" [src]="serverPath+img.img"
              [alt]="img.altImage || 'images' ">
          </div>

        </ng-container>
        <ng-container *ngIf="img.type==3">

          <div *ngIf="img.autoplay==0">
            <video controls (click)="playVideo()" loop="loop" fxLayoutAlign="space-evenly stretch" style="width:100% ;"
              [style.height]="item.height" [style.margin-right]="item.gapBetweenImage"
              [ngStyle.lt-md]="{'height': item.heightMob}">
              <source [src]="serverPath+img.img| safe: 'resourceUrl'" [alt]="img.altImage || 'images'" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div *ngIf="img.autoplay==1">
            <video oncanplay="this.play()" onloadedmetadata="this.muted = true" autoplay loop playsinline="playsinline"
              style="width:100% ;" [style.height]="item.height" [style.margin-right]="item.gapBetweenImage"
              [ngStyle.lt-md]="{'height': item.heightMob}">
              <source [src]="serverPath+img.img| safe: 'resourceUrl'" [alt]="img.altImage || 'images'" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
          <div *ngIf="img.autoplay==2">
            <video oncanplay="this.play()" onloadedmetadata="this.muted = true" autoplay muted loop="loop"
              style="width:100% ;" [style.height]="item.height" [style.margin-right]="item.gapBetweenImage"
              [ngStyle.lt-md]="{'height': item.heightMob}">
              <source [src]="serverPath+img.img| safe: 'resourceUrl'" [alt]="img.altImage || 'images'" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>

        </ng-container>
      </div>
      <!-- <div class="copilot-pdf-label">Estimate</div> -->
    </div>
  </div>
</div>